import * as THREE from "three";
import {LIGHT} from "utils/constants";

class Light {
  static createLight(type) {
    let light = undefined;
    switch (type) {
      case LIGHT.HEMISPHERE:
        light = new THREE.HemisphereLight(0xa9d3e8, 0x666c6f, 0.6);
        light.position.set(0, 10, 0);
        light.name = "HemisphereLight";
        break;
      case LIGHT.POINT:
        light = new THREE.PointLight(0xffffff, 1, 0);
        light.castShadow = true;
        light.name = "PointLight";
        break;
      case LIGHT.SPOT:
        light = new THREE.SpotLight(0xffffff, 1, 0, Math.PI * 0.1, 0);
        light.position.set(5, 10, 7.5);
        light.castShadow = true;
        light.name = "SpotLight";
        break;
      case LIGHT.DIRECTIONAL:
        light = new THREE.DirectionalLight(0xffffff, 0.6);
        light.position.set(5, 10, 7.5);
        light.castShadow = true;
        light.name = "DirectionalLight";
        break;
      case LIGHT.AMBIENT:
        light = new THREE.AmbientLight(0xffffff, 0.6);
        light.position.set(5, 10, 7.5);
        light.name = "AmbientLight";
        break;
      default:
        break;
    }

    return light;
  }
}
export default Light;
